import { ConfigObj } from '../utils/'

const defaultOpts = {
  message: 'Nothing to show'
}

/**
 * Initialize the script
 */
export default class LiveRoles {
  constructor($el, opts) {
    this.$el = $el
    this.options = ConfigObj.merge(defaultOpts, opts)
    this.$roles = undefined
  }

  init() {
    /**
     * TODO  Make a more robust check for the API activity or existance of html response data
    **/
      setTimeout(this.checkIfRolesExist.bind(this), 700)
  }


  // Add links to the categories and send them to the vacancy page with same category name anchor tag to the link
  addLinks() {
    const siteName = document.cookie.match(/_site_url_name=(\w+)/)[1]
    this.$roles.forEach($item => {
        const $link = document.createElement('a')
      $link.href = `/${siteName}/careers/vacancies/#${$item.innerText.toLowerCase().replace(' ', '-')}`
      $link.innerText = $item.innerText
      $item.innerHTML = ''
      $item.appendChild($link)
    })

  }

  // Add this message in case no role available
  addMarkUp() {
    this.$el.innerHTML = `<p class="ps-job-category-list__message">${this.options.message}</p>`;
  }


  // if Roles exist then create the link, if not call the AddMarkup function to show message
  checkIfRolesExist() {
    this.$roles = [... this.$el.querySelectorAll('.whr-group')]
    this.$roles.length > 0 ? this.addLinks() : this.addMarkUp()
  }

}



// WEBPACK FOOTER //
// ./js/modules/LiveRoles.js